export const ShareFunctions = {
  headerScroll: function() {
    const conteudo = document.querySelector('.conteudoInterno')
      const headerTitle = document.querySelector('.headerSec')
      if (conteudo.scrollTop > 0) {
        headerTitle.style.padding = '10px 4% 5px 4%'
    } else {
       headerTitle.style.padding = '40px 4% 5px 4%'
    }
  }
}